import { useState, useEffect } from "react";
import { Input, Button } from "reactstrap";

const MultipleInput = ({ name, initialData = [], placeholder, onChange }) => {
    const isValidArray = (arr) =>
        Array.isArray(arr) && arr.every((item) => typeof item === "string");

    const [inputs, setInputs] = useState(isValidArray(initialData) ? initialData : [""]);

    useEffect(() => {
        setInputs(isValidArray(initialData) ? initialData : [""]);
    }, [initialData]);


    const handleInputChange = (index, value) => {
        const newInputs = [...inputs];
        newInputs[index] = value;
        setInputs(newInputs);
        onChange(name, newInputs); // Kirim data ke Redux
    };

    const addInput = () => {
        setInputs([...inputs, ""]);
    };

    const removeInput = (index) => {
        const newInputs = inputs.filter((_, i) => i !== index);
        setInputs(newInputs);
        onChange(name, newInputs); // Update ke Redux setelah hapus
    };

    return (
        <div>
            {inputs.map((input, index) => (
                <div key={index} className="d-flex mb-2">
                    <Input
                        type="text"
                        placeholder={`${placeholder} ke-${index + 1}`}
                        value={input}
                        onChange={(e) => handleInputChange(index, e.target.value)}
                        className="me-2"
                    />
                    <Button color="danger" onClick={() => removeInput(index)} style={{ padding: '4px 8px', fontSize: '18px' }}>
                        <i className="fa fa-trash"></i>
                    </Button>
                </div>
            ))}

            <Button color="primary" onClick={addInput} style={{ padding: '4px 8px', fontSize: '12px' }}>
                <i className="fa fa-plus"></i>
            </Button>
        </div>
    );
};

export default MultipleInput;
